import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../core/shared/shared.module";
import { LoginRest } from "../../login/login.rest";
import { WorklogsRest } from "../worklogs.rest";
import { WorklogsListComponent } from "./worklogs-list.component";
import { WorklogsListRouting } from "./worklogs-list.routing";
import { NgxSelectModule } from "ngx-select-ex";
import { DictionaryRest } from "../../dictionaries/dictionary/dictionary.rest";
import { DateInputComponent } from "../../core/shared/date-input/date-input.component";
import { WorklogDetailsRouting } from "../worklog-details/worklog-details.routing";

@NgModule({
    imports: [
      CommonModule,
      WorklogsListRouting,
      SharedModule      
    ],
    declarations: [WorklogsListComponent],
    exports: [],
    providers : [WorklogsRest, LoginRest, DictionaryRest]
  })
  export class WorklogsListModule { }